export default "__VITE_ASSET__8c59d75a__"